import * as React from 'react';
import styled from 'styled-components';
import { Colors, Heading2, Text, BREAK_POINTS, Metrics } from '@origin-digital/style-guide';
import { isExperienceEnabled } from '@origin-digital/features';
import { personalisedHeaderMbox } from './PersonalisedHeader';
import { LightbulbSvg } from './LightbulbSvg';

const Container = styled.div`
  background-color: #fa4616;
  color: ${Colors.WHITE};
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0 16px;
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    padding: 0 30px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.XL}) {
    padding: 0;
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-basis: 33%;
  @media screen and (max-width: ${BREAK_POINTS.Max.SM}) {
    display: none;
  }
  svg {
    width: 99px;
    height: 136px;
    @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
      width: 138px;
      height: 182px;
    }
  }
`;

const Content = styled.div`
  padding: 24px 0;
  margin: auto 0;
  flex-basis: 100%;
  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    flex-basis: 67%;
    padding: 32px 0;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 48px 0;
  }
  > * {
    margin-bottom: 16px;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

const Line1Text = styled(Text)`
  font-size: 16px;
  line-height: 24px;
  font-weight: ${Metrics.FontWeights.REGULAR};
  color: ${Colors.WHITE};
  @media screen and (min-width: ${BREAK_POINTS.Min.SM}) {
    font-size: 16px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.MD}) {
    font-size: 18px;
  }
  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    font-size: 20px;
    line-height: 28px;
  }
`;

const HeadingContainer = styled.div`
  h2 {
    @media screen and (max-width: ${BREAK_POINTS.Max.SM}) {
      font-size: 18px;
    }
  }
`;

interface HeaderContentProps {
  stateName: string;
  customerType: string;
}

export const HeaderContent = ({ stateName, customerType }: HeaderContentProps) => {
  const showExperience = isExperienceEnabled(personalisedHeaderMbox);

  return showExperience ? (
    <Container>
      <div className="section-row">
        <InnerContainer>
          <Content>
            <HeadingContainer>
              <Heading2 fontWeight="bold" color="white" text={`Good news ${stateName}`} />
            </HeadingContainer>
            <Line1Text>
              We've reduced electricity usage charges from 1 July for new and existing{' '}
              {customerType} customers.
            </Line1Text>
          </Content>
          <ImageContainer>
            <LightbulbSvg />
          </ImageContainer>
        </InnerContainer>
      </div>
    </Container>
  ) : null;
};
